import {Component, EventEmitter, Injector, Input, OnInit, Output, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {CompanyService} from "../../../../services/company/company.service";
import {Order} from "../../../../models/shop/order";
import {OrderService} from "../../../../services/order/order.service";
import {ShopBaseComponent} from "../../shop-base.component";
import {OrderAddressService} from "../../../../services/order-address/order-address.service";
import {OrderAddress} from "../../../../models/shop/orderAddress";
import {Company} from "../../../../models/company";
import {environment} from "../../../../environments/environment";

@Component({
  selector: 'app-checkout-details',
  templateUrl: './checkout-details.component.html',
})
export class CheckoutDetailsComponent extends ShopBaseComponent implements OnInit {
    @Input() tabNumber: number = 0;
    @Output() increaseTabNum: EventEmitter<void> = new EventEmitter<void>();
    @Output() shippingPrice = new EventEmitter<number>();
    @ViewChild('nexiForm') nexiForm?: any;
    @ViewChild('nexiRatesForm') nexiRatesForm?: any;

    infoForm: FormGroup = new FormGroup({});
    disableButton: boolean = true;
    companyShipmentType?: any;
    selectedShipment?: any;

    company: Company = new Company();
    companyId: string = localStorage.getItem('wisper_companyId') ?? '';
    userId?: string | null;

    products?: any[] = [];

    shipmentData?: OrderAddress;
    differentFiscalAddress: boolean = false;
    address: OrderAddress = new OrderAddress();

    nexiAlias: string | undefined;
    nexiRatesAlias: string | undefined;
    importo: number = 0;
    divisa: string = 'EUR';
    codTrans: string = '';
    url: string = '/thankyou';
    url_back: string = '/shop/product';
    urlpost: string = '';
    value3dsDinamico: string = 'SCA';
    nexiMac: string = '';
    nexiRatesMac: string = '';
    email: string = '';
    order: Order = new Order();

    paymentMethod: string = '';
    termsAndConditions: boolean = false;

    constructor(private fb: FormBuilder,
                public serviceInjector: Injector,
                private companyService: CompanyService,
                private orderService: OrderService,
                private addressService: OrderAddressService,) {
        super(serviceInjector);
    }

    ngOnInit() {
        const companyId = localStorage.getItem('wisper_companyId');
        console.log("companyId->", companyId)
        if (companyId) {
            this.companyService.getCompanyById(companyId).then((company) => {
                if (company.data.shipmentPrice) {
                    this.companyShipmentType = [{
                        id: 'stardard',
                        type: 'Spedizione standard',
                        price: company.data.shipmentPrice
                    },
                        {id: 'local', type: 'Ritiro presso sede', price: 0},
                        {id: 'noShipment', type: 'Acquisto senza spedizione', price: 0}];
                } else {
                    this.companyShipmentType = [{id: 'local', type: 'Ritiro presso sede', price: 0},
                        {id: 'noShipment', type: 'Acquisto senza spedizione', price: 0}];
                }
                this.company = company.data;


            });
        }

        this.infoForm = this.fb.group({
            email: ['', [Validators.required, Validators.email]],
            fiscalCode: ['', [Validators.required, Validators.minLength(16), Validators.maxLength(16), Validators.pattern(/^[a-zA-Z0-9]{16}$/)]],
            firstName: ['', Validators.required],
            lastName: ['', Validators.required],
            address: ['', Validators.required],
            optional: [''],
            zip: ['', Validators.required],
            city: ['', Validators.required],
            province: ['', Validators.required]
        });

        this.products = this.getProductsLocalStorage();

    }

    saveInfo() {
        if (this.infoForm.valid) {
            this.showSpinner();
            const existingAddress = {...this.address};
            const {fiscalCode, ...formData} = this.infoForm.value;
            Object.assign(existingAddress, formData);
            if (fiscalCode) {
                this.order.fiscalCode = this.normalizeFiscalCode(fiscalCode);
            }
            this.address = existingAddress;

            this.setFiscalAddress();
            this.addressService.create(this.address).subscribe((response: any) => {
                if (response.success) {
                    this.shipmentData = response.data;
                    this.increaseTabNum.emit();
                    this.disableButton = false;
                } else {
                    this.showErrorMessage('Errore durante il salvataggio delle informazioni')
                }
                this.hideSpinner();

            });
        } else {
            this.disableButton = true;
        }
    }

    saveOrder() {
        this.userId = this.getUserId();
        const fiscalCode = this.infoForm.get('fiscalCode')?.value;
        if (fiscalCode) {
            this.order.fiscalCode = this.normalizeFiscalCode(fiscalCode);
        }
        if (this.companyId) this.order.companyId = this.companyId;
        if (this.userId) this.order.userId = this.userId;
        if (this.shipmentData) this.order.addressId = this.shipmentData.id;
        this.order.totalPrice = this.cartSubTotal(this.products) + parseFloat(this.selectedShipment.price);
        this.order.shippingPrice = this.selectedShipment.price;
        this.order.shippingType = this.selectedShipment.type;
        this.shippingPrice.emit(this.selectedShipment.price);
        this.order.barcodes = this.products ? this.products.map((product) => {
            return {
                barcodeId: product.barcode,
                quantity: product.quantity,
                subTotal: product.price * product.quantity
            }
        }) : [];

        this.increaseTabNum.emit();
    }

    createOrder() {
        this.order.paymentMethod = this.paymentMethod;
        this.orderService.create(this.order).subscribe((response: any) => {
            if (response.success) {
                if (this.paymentMethod === 'nexi') {
                    this.nexiAlias = response.data.alias;
                    this.url = environment.baseUrl + '/thankyou';
                    this.url_back = environment.baseUrl + '/shop';

                    this.importo = response.data.centsAmount;
                    this.codTrans = response.data.transactionId;
                    this.nexiMac = response.data.mac;
                    this.urlpost = response.data.urlpost;


                    setTimeout(() => this.nexiForm!.nativeElement.submit(), 100);
                }

                if (this.paymentMethod === 'nexiRates') {
                    this.nexiRatesAlias = response.data.alias;
                    this.url = environment.baseUrl + '/thankyou';
                    this.url_back = environment.baseUrl + '/shop';

                    this.importo = response.data.centsAmount;
                    this.codTrans = response.data.transactionId;
                    this.nexiRatesMac = response.data.mac;
                    this.urlpost = response.data.urlpost;

                    setTimeout(() => this.nexiRatesForm!.nativeElement.submit(), 100);
                }

                if (this.paymentMethod === 'transfer') {

                    if (!this.company.wireTransferIban && !this.company.wireTransferBeneficiary) {
                        this.showErrorMessage('Errore nel recupero dei dati necesssari per il bonifico');
                        return;
                    }

                    console.log('transfer', response.data.orderNum)

                    this.goTo('/iban-details', {ibanSelected: true, orderNum: response.data.orderNumber,});
                }

                //Banca sella rates
                if (this.paymentMethod === 'appPagoRates') {
                    window.location.href = response.data.url;
                }
            } else {
                this.showErrorMessage('Errore durante l\'operazione di pagamento')
            }
        });
    }

    getFullAddress() {
        return (this.infoForm.get('address')?.value + ', ' + this.infoForm.get('zip')?.value + ', ' + this.infoForm.get('city')?.value + ' ' + this.infoForm.get('province')?.value);
    }

    setSelectedShipment(shipment: string) {
        this.selectedShipment = shipment;
        console.log(this.selectedShipment)
    }

    getNexiUrl() {
        return environment.nexiUrl;
    }

    getValidMail(email: string) {
        return email.replaceAll("+1", "");
    }

    setFiscalAddress() {
        if (!this.differentFiscalAddress && this.address) {
            this.address.legalFirstName = this.address.firstName;
            this.address.legalLastName = this.address.lastName;
            this.address.legalAddress = this.address.address;
            this.address.legalAddressOptional = this.address.addressOptional;
            this.address.legalZip = this.address.zip;
            this.address.legalCity = this.address.city;
            this.address.legalProvince = this.address.province;
        }
    }

    differentFiscalAddressChange() {
        this.differentFiscalAddress = !this.differentFiscalAddress;
    }

    normalizeFiscalCode(value: string): string {
        return value.replace(/\s+/g, '').toUpperCase();
    }

    onFiscalCodeBlur() {
        const control = this.infoForm.get('fiscalCode');
        if (control?.value) {
            control.setValue(this.normalizeFiscalCode(control.value), {emitEvent: false});
        }
    }

}
